export default __webpack_public_path__ + "static/media/MoodCry.e009900e.png";